import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaTwitter } from 'react-icons/fa';

const Social = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #0077b6, #0093e9);
  text-align: center;
  color: #fff;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-family: 'Raleway', sans-serif;
  animation: fadeIn 2s ease-in-out;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  font-family: 'Raleway', sans-serif;
  animation: fadeIn 2s ease-in-out;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

const IconWrapper = styled.a`
  display: inline-block;
  margin: 1rem;
  padding: 1rem;
  border-radius: 50%;
  background-color: #fff;
  color: #1da1f2;
  animation: ${pulse} 2s infinite;

  &:hover {
    animation: ${pulse} 0.5s infinite;
  }

  svg {
    transition: transform 0.3s;
  }

  &:hover svg {
    transform: scale(1.2);
  }
`;

const Button = styled.a`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  margin-top: 1rem;
  background-color: #1da1f2;
  color: #fff;
  border-radius: 25px;
  font-size: 1rem;
  text-decoration: none;
  font-family: 'Raleway', sans-serif;
  transition: background-color 0.3s, transform 0.3s;

  &:hover {
    background-color: #0d8ded;
    transform: translateY(-5px);
  }
`;

const SocialSection = () => {
  return (
    <Social id="social">
      <Title>Connect with Us</Title>
      <Subtitle>Follow us on Twitter for the latest updates.</Subtitle>
      <IconWrapper href="https://twitter.com/adchainsolana" target="_blank" rel="noopener noreferrer">
        <FaTwitter size={40} />
      </IconWrapper>
      <Button href="https://twitter.com/adchainsolana" target="_blank" rel="noopener noreferrer">
        Follow Us
      </Button>
    </Social>
  );
};

export default SocialSection;
